"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Cross = function Cross(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M0 0V24H24V0H0ZM17.3535 16.6465C17.4007 16.6927 17.4383 16.7479 17.4641 16.8087C17.4898 16.8696 17.5033 16.935 17.5036 17.0011C17.504 17.0672 17.4912 17.1327 17.4661 17.1938C17.4409 17.2549 17.4039 17.3105 17.3572 17.3572C17.3105 17.4039 17.2549 17.4409 17.1938 17.4661C17.1327 17.4912 17.0672 17.504 17.0011 17.5036C16.935 17.5033 16.8696 17.4899 16.8087 17.4641C16.7479 17.4383 16.6927 17.4008 16.6465 17.3536L12 12.7071L7.35353 17.3536C7.25943 17.4457 7.13277 17.4971 7.00105 17.4964C6.86934 17.4957 6.74321 17.4431 6.65007 17.3499C6.55694 17.2568 6.50431 17.1307 6.50364 16.9989C6.50297 16.8672 6.55429 16.7406 6.64647 16.6465L11.2929 12L6.64644 7.35356C6.55268 7.25979 6.5 7.13261 6.5 7C6.5 6.86739 6.55268 6.74021 6.64644 6.64644C6.74021 6.55268 6.86739 6.5 7 6.5C7.13261 6.5 7.25979 6.55268 7.35356 6.64644L12 11.2929L16.6464 6.64644C16.6928 6.60001 16.748 6.56318 16.8086 6.53805C16.8693 6.51292 16.9343 6.49998 17 6.49998C17.0656 6.49997 17.1307 6.51291 17.1913 6.53803C17.252 6.56316 17.3071 6.59999 17.3536 6.64642C17.4 6.69285 17.4368 6.74797 17.462 6.80863C17.4871 6.8693 17.5 6.93432 17.5 6.99998C17.5 7.06564 17.4871 7.13067 17.462 7.19133C17.4368 7.252 17.4 7.30712 17.3536 7.35356L12.7071 12L17.3535 16.6465Z",
    fill: props.foregroundColor
  }));
};

Cross.defaultProps = {
  altText: "Cross",
  backgroundColor: "#FFFFFF",
  foregroundColor: "#2D5AB4"
};
Cross.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Cross;
exports.default = _default;